import { ModuleWithProviders, NgModule } from '@angular/core';
import { WebSocketService } from './e-connect-web-socket.service';

@NgModule({
    declarations: [],
    imports: [],
    exports: []
})
export class EConnectWebSocketModule {
    static forRoot(environment): ModuleWithProviders<EConnectWebSocketModule> {
        return {
            ngModule: EConnectWebSocketModule,
            providers: [
                WebSocketService,
                { provide: 'env', useValue: environment }]
        };
    }
}